import Modal from "shared/components/modal"
import parse from "html-react-parser"
import styles from "app/components/upgrade_plan_modal/shared_modal.module.scss"
import { ReactNode } from "preact/compat"
import iconSuccessCheck from "images/icons/icon-success-check-green.svg?raw"
import iconSuccessGrayCheck from "images/icons/icon-success-check-gray.svg?raw"

interface ButtonConfig {
  label: string
  onClick: () => void
  variant: "primary" | "secondary"
}

interface SuccessModalProps {
  badge?: string
  buttons: ButtonConfig[]
  successContent?: ReactNode
  featuresLabel?: string
  features?: string[]
  title: string
  visible: boolean
  onClose: () => void
}

const SuccessModal = ({
  badge,
  buttons,
  successContent,
  featuresLabel,
  features,
  title,
  visible,
  onClose,
}: SuccessModalProps) => {
  return (
    <div className={styles["modal-container"]} data-fullscreen-modal>
      <Modal show={visible} closeListener={onClose} includeCloseX={true}>
        <div className="success-modal-icon">{parse(iconSuccessCheck)}</div>
        <h2 className="mt0 mb0">{title}</h2>
        {badge && <div className="success-modal-badge">{parse(badge)}</div>}
        {features && features.length > 0 && (
          <div className="success-modal-features">
            {featuresLabel && <p className="success-modal-features-label">{featuresLabel}</p>}
            <ul>
              {features.map((feature, i) => (
                <li key={i}>
                  {parse(iconSuccessGrayCheck)}
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        )}
        {successContent}
        <div className="action-buttons-row">
          {buttons.map((button, i) => (
            <button
              key={i}
              className={button.variant === "primary" ? "button-tertiary" : "button-tertiary button-outlined"}
              onClick={button.onClick}
            >
              {button.label}
            </button>
          ))}
        </div>
      </Modal>
    </div>
  )
}

export default SuccessModal
